import React, { useState } from 'react'
import { TripForm } from '../components/forms/TripForm'
import { AttachmentType, CaseReportId, TravelContextType } from '../models'

const caseReportId: CaseReportId = '123'

const initialInsuranceData: TravelContextType = {
  touroperator: '',
  companyName: '',
  departureDate: null,
  returnDate: null,
  attachmentList: [
    {
      attachmentType: AttachmentType.POLICY,
      attachments: [
        {
          attachmentId: '123',
          fileName: 'muj soubour.xlsx',
        },
      ],
    },
  ],
}

const TripDebug = () => {
  const [tripFormData, setTripFormData] = useState<TravelContextType | object>(
    initialInsuranceData
  )

  const insuranceFormPageSubmitted = (value: TravelContextType) => {
    alert(
      'DEBUG\nHealthPage submitted\nNow the page will be reset to blank data...'
    )

    console.log(value, 'value from Debug')

    // reset data in the form to empty data
    setTripFormData({ travelType: 'I' })

    // delay 10 sec
    new Promise((resolve) => setTimeout(resolve, 10000)).then(() => {
      alert('DEBUG\nNow we will display the previously edited values...')
      setTripFormData(value)
    })
  }

  const handleInsurancePageBack = () => {
    alert('Page back')
  }

  return (
    <TripForm
      caseReportId={caseReportId}
      tripFormData={tripFormData}
      isContinueInProgress={false}
      errorMessage={''}
      onPageContinue={insuranceFormPageSubmitted}
      onPageBack={handleInsurancePageBack}
      onDataChanged={(isChanged: boolean) => {
        /* ignore */
      }}
      caseType="CA"
    />
  )
}

export default TripDebug
